import { useCallback, useEffect, useState } from 'react';
import './App.css';

const SECTION_IDS = ['about', 'courses', 'who-should-attend', 'what-to-expect','Project', 'contact'];

const COURSE_DATA = [
    {
    title: 'BIM for Architectural & Structural',
    image: 'https://staging.bimtraining.net/wp-content/uploads/2026/04/arch.jpg',
    features: [
      { label: 'Duration:', value: '6 months' },
      { label: 'Assessments:', value: ' 4 no.s' },
      { label: 'Internship with stipend::', value: ' 3 months' },
      { label: 'Softwares covered ::', value: ' 4 no.s' },
      { label: 'Eligibility: :', value: 'B.Tech / M.Tech / B.Arch / M.Arch' },  
    ],
  },
  {
    title: 'BIM for MEP',
    image: 'https://staging.bimtraining.net/wp-content/uploads/2026/04/mep.jpg',
    features: [
      { label: 'Duration:', value: '6 months' },
      { label: 'Assessments:', value: ' 4 no.s' },
      { label: 'Internship with stipend::', value: ' 3 months' },
      { label: 'Softwares covered ::', value: ' 4 no.s' },
      { label: 'Eligibility: :', value: ' B.Tech / M.Tech / B.Arch / M.Arch ' },  



    ],
  },
  {
    title: 'BIM for Façade Design',
    image: 'https://staging.bimtraining.net/wp-content/uploads/2026/04/facade.jpg',
    features: [
     { label: 'Duration:', value: '6 months' },
      { label: 'Assessments:', value: ' 4 no.s' },
      { label: 'Internship with stipend::', value: ' 3 months' },
      { label: 'Softwares covered ::', value: ' 4 no.s' },
      { label: 'Eligibility: :', value: '   B.Tech / M.Tech / B.Arch / M.Arch ' },  
    ],
  },

];

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('about');
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [formStatus, setFormStatus] = useState({ message: '', type: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const scrollToSection = useCallback((id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 40);
      const offset = window.scrollY + 140;
      let current = 'about';
      for (const sectionId of SECTION_IDS) {
        const el = document.getElementById(sectionId);
        if (el && el.offsetTop <= offset) {
          current = sectionId;
        }
      }
      setActiveSection(current);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setFormStatus({ message: '', type: '' });
    try {
      await new Promise((r) => setTimeout(r, 500));
      setFormStatus({
        message: 'Thank you! We will get back to you soon.',
        type: 'success',
      });
      setFormData({ name: '', email: '', message: '' });
    } catch {
      setFormStatus({
        message: 'Something went wrong. Please try again.',
        type: 'error',
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bim-training-page">
      {/* Navigation */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <div className="logo">
            
            <img
              src={
                isScrolled
                  ? 'https://staging.bimtraining.net/wp-content/uploads/2026/04/logo-scaled.png'
                  : 'https://staging.bimtraining.net/wp-content/uploads/2026/04/logo-white-scaled.png'
              }
              alt="Advenser Academy"
            />
          </div>
          <ul className="nav-menu">
            <li onClick={() => scrollToSection('about')} className={activeSection === 'about' ? 'active' : ''}>About</li>
            <li onClick={() => scrollToSection('courses')} className={activeSection === 'courses' ? 'active' : ''}>Course Offered</li>
            <li onClick={() => scrollToSection('who-should-attend')} className={activeSection === 'who-should-attend' ? 'active' : ''}>Who should attend</li>
            <li onClick={() => scrollToSection('what-to-expect')} className={activeSection === 'what-to-expect' ? 'active' : ''}>What to expect</li>
            <li onClick={() => scrollToSection('project')} className={activeSection === 'project' ? 'active' : ''}>Project</li>
            <li onClick={() => scrollToSection('contact')} className={activeSection === 'contact' ? 'active' : ''}>Contact</li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section" id="home">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="highlight">BIM</span> TRAINING PROGRAM
          </h1>
          <p className="hero-subtitle">
            Transform your team's efficiency with Advenser's tailored BIM training programs.
          </p>
          <button type="button" className="cta-button" onClick={() => scrollToSection('contact')}>
            APPLY NOW
            <svg className="arrow-icon" viewBox="0 0 17 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M 0 0 L 20 12.5 L 0 25 Z" fill="white"/>
            </svg>
          </button>
          <div className="software-badges">
          <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/AUTOcad.png" alt="AutoCAD" />
            <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/REVIT.png" alt="Revit" />
            <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/NAVISWORK.png" alt="Navisworks" />
            <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/construction.png" alt="Construction Cloud" />
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section" id="about">
        <div className="container">
          <div className="about-grid">
            <div className="experience-box">
              <div className="experience-number">18</div>
              <div className="experience-text">
                <p>Years experience working</p>
                <span className="since">Since 2007</span>
              </div>
            </div>
            <div className="about-content">
              <h2 className="section-title gradient-text">
                Interested in Learning BIM?
              </h2>
              <p className="about-description">
                Advenser offers a comprehensive Building Information Modeling (BIM) training program that is designed to equip professionals with industry-relevant skills and expertise. The BIM process provides a data-rich, intelligent, 3D representation of a project and is widely utilized in the architecture, engineering, design and construction (AEC) industries.
              </p>
            </div>
          </div>
          <p className="challenge-statement gradient-text">
            Fresh graduates often lack exposure to real-world projects, multidisciplinary coordination, and global BIM standards. Additionally, there is a smart talent shortage within the AEC sector, particularly below the mid-managerial level.
          </p>
        </div>
      </section>

      {/* Course Offered Section */}
      <section className="courses-section" id="courses">
        <div className="container">
          <h2 className="section-title-main">Course Offered</h2>

          <div className="course-tabs">
            {COURSE_DATA.map((course, index) => (
              <button
                key={course.title}
                type="button"
                className={`tab-button ${activeTab === index ? 'active' : ''}`}
                onClick={() => setActiveTab(index)}
              >
                {course.title}
              </button>
            ))}
          </div>

          <div className="course-details">
            <div className="course-image">
              <img src={COURSE_DATA[activeTab].image} alt={COURSE_DATA[activeTab].title} />
            </div>
            <div className="course-info">
              <h3 className="course-title gradient-text">{COURSE_DATA[activeTab].title}</h3>
              <ul className="course-features">
                {COURSE_DATA[activeTab].features.map((feature) => (
                  <li key={`${feature.label}-${feature.value}`}>
                    <span className="arrow">{'\u27A4'}</span>
                    <strong>{feature.label}</strong> {feature.value}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* What You Will Learn */}
          <h3 className="subsection-title gradient-text">What You Will Learn</h3>
          <div className="benefits-grid">
            <div className="benefit-card">
              <div className="benefit-icon">
                <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/soft-icon.png" alt="Software Training" />
              </div>
              <h4>Expert-Led Software Training</h4>
              <p>Comprehensive training in leading BIM tools including AutoCAD, Revit, Navisworks, and Autodesk Construction Cloud (ACC).</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/indenship-icon.png" alt="Project Exposure" />
              </div>
              <h4>Real Project Exposure</h4>
              <p>Gain practical experience by working on live industry projects under the guidance of expert mentors.</p>
            </div>
            <div className="benefit-card">
              <div className="benefit-icon">
                <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/project-icon.png" alt="Internship" />
              </div>
              <h4>Paid Internship Opportunity</h4>
              <p>Earn a stipend during the internship phase while gaining valuable on-site industry exposure</p>
            </div>
          </div>
        </div>
      </section>

      {/* Who Should Attend Section */}
      <section className="who-should-attend-section" id="who-should-attend">
        <div className="container">
          <div className="who-attend-grid">
            <div className="who-attend-image">
              <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/students.png" alt="Students" />
            </div>
            <div className="who-attend-content">
              <h2 className="section-title-main white">Who Should Attend</h2>
              <p className="who-attend-intro">
                This program caters to students and working professionals and is tailored to meet their area of interest or specialization.
              </p>
              <ul className="who-attend-list">
                <li>Fresh graduates in engineering and construction seeking to specialize in BIM</li>
                <li>Early-career professionals aiming to enhance project coordination and modeling skills</li>
                <li>Students aspiring to build a strong foundation in BIM technology</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* What to Expect Section */}
      <section className="what-to-expect-section" id="what-to-expect">
        <div className="container">
          <h2 className="section-title-main">What to Expect</h2>
          <div className="expectations-grid">
            <div className="expectation-item">
              <div className="expectation-number">1</div>
              <p>Theory & Practical Insights in BIM</p>
            </div>
            <div className="expectation-item">
              <div className="expectation-number">2</div>
              <p>Real-Time Scenarios & BIM Projects</p>
            </div>
            <div className="expectation-item">
              <div className="expectation-number">3</div>
              <p>3 Months of Intensive BIM Training</p>
            </div>
            <div className="expectation-item">
              <div className="expectation-number">4</div>
              <p>3 Months of Hands-on Internship</p>
            </div>
            <div className="expectation-item">
              <div className="expectation-number">5</div>
              <p>Mentoring from Industry Experts</p>
            </div>
          </div>
        </div>



     
        
    



      </section>


      <section className="project-section" id="project">
     <h2 className="section-title-main">International BIM Projects Across Sectors</h2>
          <div className="project-grid">

            <div className="project-card">
              <div className="project-icon">
                <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/project-1.jpg" alt="Software Training" />
              </div>
              <h4>Rebar Detailing for a Museum Project, UAE</h4>
             
            </div>
            <div className="project-card">
              <div className="project-icon">
                <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/project-2.jpg" alt="Project Exposure" />
              </div>
              <h4>Rebar Detailing for a Museum Project, UAE</h4>
             
            </div>
            <div className="project-card">
              <div className="project-icon">
                <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/project-3.jpg" alt="Internship" />
              </div>
              <h4>Mixed-Use Building Project, UAE</h4>
             
            </div>
               <div className="project-card">
              <div className="project-icon">
                <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/project-4.jpg" alt="Internship" />
              </div>
              <h4>Multi-Storey Residential Project, AUS</h4>
              
            </div>

            </div>


      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact">
                   <div className="contact-header">
          <div className="contact-info">
            <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/location.png" alt="Location" className="location-icon" />
            <div className="address">
              <strong>Advenser Academy</strong><br />
              Unit No. 019, Ground Floor<br />
              Lulu Cyber Tower 1<br />
              Infopark Phase 1, Kakkanad<br />
              Kochi – 682042
            </div>
            <div className="social-icons">
              <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/icon-fb.png" alt="Social Media" />
               <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/icon-insta.png" alt="Social Media" />
                <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/icon-youtube.png" alt="Social Media" />
            </div>
          </div>
        </div>
 

        <div className="contact-form-wrapper">
          <div className="map-container">


            <div  className="map-container-map">
            <img src="https://staging.bimtraining.net/wp-content/uploads/2026/04/map.png" alt="Map" className="map-image" />

            
</div>

            
            <div className="contact-form-container">
            <form onSubmit={handleSubmit} className="contact-form">
              <h3>Contact Us</h3>

              {formStatus.message && (
                <div
                  className={`form-status ${formStatus.type}`}
                  style={{
                    padding: '1rem',
                    marginBottom: '1rem',
                    borderRadius: '4px',
                    backgroundColor: formStatus.type === 'success' ? '#d4edda' : '#f8d7da',
                    color: formStatus.type === 'success' ? '#155724' : '#721c24',
                    border: `1px solid ${formStatus.type === 'success' ? '#c3e6cb' : '#f5c6cb'}`,
                  }}
                >
                  {formStatus.message}
                </div>
              )}

            <div className="form-group-top">

              <div className="form-group">
                <label htmlFor="contact-name">Name*</label>
                <input
                  id="contact-name"
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleFormChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
              <div className="form-group">
                <label htmlFor="contact-email">Email*</label>
                <input
                  id="contact-email"
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleFormChange}
                  required
                  disabled={isSubmitting}
                />
              </div>
           </div>

              <div className="form-group">
                <label htmlFor="contact-message">Message</label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={4}
                  value={formData.message}
                  onChange={handleFormChange}
                  disabled={isSubmitting}
                />
              </div>
              <button type="submit" className="submit-button" disabled={isSubmitting}>
                {isSubmitting ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </div>




          </div>        
        </div>

        <footer className="footer">
          <p>© Copyright 2026 Advenser Academy | Privacy Policy</p>
        </footer>
      </section>
    </div>
  );
}

export default App;
